var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createSlice } from '@reduxjs/toolkit';
import { fetchLatestIgnitionMessage, fetchLatestOdometerMessage, fetchLatestPositionMessage } from '../../adapters/StreamDataAdapter';
import { fetchLatestFromCdc } from "../../adapters/CdcAdapter";
var getInitialState = function () {
    var state = {
        odometer: null,
        ignition: null,
        position: null,
        isLoading: false,
        isReLoadingPosition: false,
        hasError: false,
        errorMessage: "",
        externalEquipmentReference: ""
    };
    return state;
};
// Slice
var slice = createSlice({
    name: 'LatestInfo',
    initialState: getInitialState(),
    reducers: {
        setIsLoading: function (state, action) {
            state.isLoading = action.payload;
        },
        setIsReLoadingPosition: function (state, action) {
            state.isReLoadingPosition = action.payload;
        },
        updateHasError: function (state, action) {
            state.hasError = action.payload !== '';
            state.errorMessage = action.payload;
        },
        updatePosition: function (state, action) {
            state.position = action.payload;
        },
        updateIgnition: function (state, action) {
            state.ignition = action.payload;
        },
        updateOdometer: function (state, action) {
            state.odometer = action.payload;
        },
        updateExtEquipmentRef: function (state, action) {
            state.externalEquipmentReference = action.payload;
        },
        resetState: function () {
            return getInitialState();
        }
    },
});
export default slice.reducer;
// Actions
var _a = slice.actions, setIsLoading = _a.setIsLoading, updateHasError = _a.updateHasError, updatePosition = _a.updatePosition, updateIgnition = _a.updateIgnition, updateOdometer = _a.updateOdometer, setIsReLoadingPosition = _a.setIsReLoadingPosition, updateExtEquipmentRef = _a.updateExtEquipmentRef, resetState = _a.resetState;
export var loadLatestData = function (externalEquipmentReference) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var latestInfo, ignitionMessageResponse, e_1, odometerMessageResponse, e_2, positionMessageResponse, e_3, error_1, message;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 11, , 12]);
                latestInfo = getState().latestInfo;
                if (latestInfo.externalEquipmentReference !== externalEquipmentReference) {
                    dispatch(resetState());
                    dispatch(updateExtEquipmentRef(externalEquipmentReference));
                }
                dispatch(setIsLoading(true));
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, fetchLatestIgnitionMessage(externalEquipmentReference)];
            case 2:
                ignitionMessageResponse = _a.sent();
                dispatch(updateIgnition(ignitionMessageResponse.data));
                return [3 /*break*/, 4];
            case 3:
                e_1 = _a.sent();
                console.error(e_1);
                dispatch(updateIgnition(null));
                return [3 /*break*/, 4];
            case 4:
                _a.trys.push([4, 6, , 7]);
                return [4 /*yield*/, fetchLatestOdometerMessage(externalEquipmentReference)];
            case 5:
                odometerMessageResponse = _a.sent();
                dispatch(updateOdometer(odometerMessageResponse.data));
                return [3 /*break*/, 7];
            case 6:
                e_2 = _a.sent();
                console.error(e_2);
                dispatch(updateOdometer(null));
                return [3 /*break*/, 7];
            case 7:
                _a.trys.push([7, 9, , 10]);
                return [4 /*yield*/, fetchLatestPositionMessage(externalEquipmentReference)];
            case 8:
                positionMessageResponse = _a.sent();
                dispatch(updatePosition(positionMessageResponse.data));
                return [3 /*break*/, 10];
            case 9:
                e_3 = _a.sent();
                console.error(e_3);
                dispatch(updatePosition(null));
                return [3 /*break*/, 10];
            case 10:
                dispatch(setIsLoading(false));
                return [3 /*break*/, 12];
            case 11:
                error_1 = _a.sent();
                message = String(error_1);
                if (error_1 instanceof Error)
                    message = error_1.message;
                dispatch(updateHasError(message));
                dispatch(setIsLoading(false));
                return [3 /*break*/, 12];
            case 12: return [2 /*return*/];
        }
    });
}); }; };
export var loadLatestDataFromCdc = function (externalEquipmentReference) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var latestInfo, cdcResponse, _a, position, odometer, ignition, error_2, message;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                latestInfo = getState().latestInfo;
                if (latestInfo.externalEquipmentReference !== externalEquipmentReference) {
                    dispatch(resetState());
                    dispatch(updateExtEquipmentRef(externalEquipmentReference));
                }
                dispatch(setIsLoading(true));
                return [4 /*yield*/, fetchLatestFromCdc(externalEquipmentReference)];
            case 1:
                cdcResponse = _b.sent();
                _a = cdcResponse.data, position = _a.position, odometer = _a.odometer, ignition = _a.ignition;
                odometer && dispatch(updateOdometer({
                    odometer: odometer.value,
                    timeMessage: odometer.timeMessage,
                    timeSaved: odometer.timeSaved,
                    isOdometerICL: false
                }));
                ignition && dispatch(updateIgnition({
                    odometer: ignition.value,
                    timeMessage: ignition.timeMessage,
                    timeSaved: ignition.timeSaved,
                }));
                position && dispatch(updatePosition({
                    latitude: position.latitude,
                    longitude: position.longitude,
                    timeMessage: position.timeMessage,
                    timeSaved: position.timeSaved,
                    timePosition: position.timePosition
                }));
                dispatch(setIsLoading(false));
                return [3 /*break*/, 3];
            case 2:
                error_2 = _b.sent();
                message = String(error_2);
                if (error_2 instanceof Error)
                    message = error_2.message;
                dispatch(updateHasError(message));
                dispatch(setIsLoading(false));
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var reLoadPositionData = function (externalEquipmentReference) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var positionMessageResponse, error_3, message, statusCode;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch(setIsReLoadingPosition(true));
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, fetchLatestPositionMessage(externalEquipmentReference)];
            case 2:
                positionMessageResponse = _a.sent();
                dispatch(updatePosition(positionMessageResponse.data));
                return [3 /*break*/, 4];
            case 3:
                error_3 = _a.sent();
                message = String(error_3);
                if (error_3 instanceof Error)
                    message = error_3.message;
                statusCode = error_3 && error_3.response && error_3.response.status;
                if (statusCode && statusCode !== 404) {
                    dispatch(updateHasError(message));
                }
                return [3 /*break*/, 4];
            case 4:
                dispatch(setIsReLoadingPosition(false));
                return [2 /*return*/];
        }
    });
}); }; };
